import LanguageIcon from "@mui/icons-material/Language";
import { Typography } from "@mui/material";
import capitalize from "lodash/capitalize";

import { ProductGuideLanguageListNode } from "../../apiHooks/useProduct";
import { BulletedList } from "../../components/BulletedList";
import { ReadMoreContainer } from "../../components/ExpandableContent";
import { LabeledSection } from "../../components/LabeledSection";
import { useProductTranslation } from "../../hooks/useProductTranslation";

export type ProductSectionGuideLanguagesProps = {
    languages: ProductGuideLanguageListNode[];
};

export function ProductSectionGuideLanguages({ languages }: ProductSectionGuideLanguagesProps) {
    const [t] = useProductTranslation();
    return (
        <LabeledSection title={t("label.guideLanguages")} Icon={LanguageIcon}>
            <ReadMoreContainer>
                <BulletedList>
                    {languages.map((x, i) => (
                        <li key={i}>
                            <Typography>{capitalize(x.name ?? "")}</Typography>
                        </li>
                    ))}
                </BulletedList>
            </ReadMoreContainer>
        </LabeledSection>
    );
}
